const isProjectDetailView = (pathname) =>
  [/\/projects\/[0-9]+/, /\/templates\/[0-9]+/, /\/lite\/[0-9]+/, /\/litecallback\/[0-9]+/].some((pattern) => pattern.test(pathname));

export default isProjectDetailView;
